

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import { pathwayTypeInfoType } from '@/types/Information';

@Component
export default class FinalDecisionOnLeaveToAppealAppLeaveRefusedPg extends Vue {  

    @informationState.Action
    public UpdatePathType!:(newPathType: pathwayTypeInfoType) => void

    public appLeaveGrantedFinalPath() {
        
        const pathType = {} as pathwayTypeInfoType;
        pathType.appLeaveGrantedFinal = true;
        this.UpdatePathType(pathType);        
        this.$emit('closeWindow');

    }

    public appLeaveRefusedFinalPath() {

        const pathType = {} as pathwayTypeInfoType;
        pathType.appLeaveRefusedFinal = true;
        this.UpdatePathType(pathType);
        this.$emit('closeWindow');
    }
}
